import axios from 'axios';
import { BASE_URL } from './constants';

//device
export const getDevice = () => axios.get(BASE_URL + '/device');

export const updateDevice = (params: Object) => axios.patch(BASE_URL + '/device', params)

//cameras
export const getCameraList = () => axios.get(BASE_URL + '/cameras');

export const getCameras = () => axios.get(BASE_URL + '/cameras/all');

export const getCameraDetails = (cameraName: string) => axios.get(BASE_URL + '/cameras/' + cameraName + '/all');

export const updateFocusSettings = (cameraName: string, params: Object) => axios.post(BASE_URL + '/camera-setting/' + cameraName, params)

export const updateCamera = (cameraName: string, body: object) => axios.patch(BASE_URL + '/cameras/' + cameraName, body);

export const setROIPoints = (cameraName: string, body: object) => axios.post(BASE_URL + '/cameras/' + cameraName + '/all', body);

//emails
export const getEmails = () => axios.get(BASE_URL + '/emails/all');

export const addEmail = (param: any) => axios.put(BASE_URL + '/emails', param);

export const deleteEmail = (param: any) => axios.delete(BASE_URL + '/emails/' + param);

export const getTargetEmails = (cameraName: string, roiID: number) => axios.get(BASE_URL + '/cameras/' + cameraName + '/roi/' + roiID + '/emails/all');

export const updateTargetEmails = (cameraName: string, roiID: number, body: object) => axios.post(BASE_URL + '/cameras/' + cameraName + '/roi/' + roiID + '/emails/all', body);

//snmp
export const getSnmpDetails = () => axios.get(BASE_URL + '/snmp-setting');

export const putSnmpDetails = (param: any) => axios.put(BASE_URL + '/snmp-setting', param);

//settings
export const importSettings = (file: any) => axios.post(BASE_URL + '/settings/import/', file);

export const exportSettings = () => axios.get(BASE_URL + '/settings/export/');

//audit logs
export const downloadLogs = (fromDate: string, toDate: string) => axios.get(BASE_URL + '/auditlog/export/' + fromDate + '/' + toDate);


//analysis
export const analyze = (body: object) => axios.post(BASE_URL + '/analyze', body);


//roi settings
export const getROISettings = (cameraName: string, roiID: string) => axios.get(BASE_URL + '/cameras/' + cameraName + '/roi/' + roiID);
export const updateROISettings = (cameraName: string, roiID: string, body: object) => axios.patch(BASE_URL + '/cameras/' + cameraName + '/roi/' + roiID, body);

//reference status check
export const startReferenceCheck = (cameraName: string, action: string) => axios.post(BASE_URL + '/reference-status-check/' + cameraName + '/' + action);

//snapshot
export const getSnapshot = (cameraName: string) => axios.post(BASE_URL + '/snapshot/' + cameraName);